import { ComplianceCategoryStatsData } from '@/redux/models';
import { RiskKeys } from '@/config';

export const entityDemoData: ComplianceCategoryStatsData = [
  {
    key: '1',
    entityCategory: RiskKeys.EXCHANGE,
    totalFunds: 85321.78,
    receivedFunds: 35154.23,
    sentFunds: 50167.55,
    totalExpenses: 21.35,
    receivedExpenses: 27.14,
    sentExpenses: 18.58,
  },
  {
    key: '2',
    entityCategory: RiskKeys.MARKETPLACE,
    totalFunds: 44658.12,
    receivedFunds: 14821.95,
    sentFunds: 29836.17,
    totalExpenses: 11.18,
    receivedExpenses: 11.44,
    sentExpenses: 11.05,
  },
  {
    key: '3',
    entityCategory: RiskKeys.MINER,
    totalFunds: 25147.53,
    receivedFunds: 10285.64,
    sentFunds: 14861.89,
    totalExpenses: 6.29,
    receivedExpenses: 7.94,
    sentExpenses: 5.5,
  },
  {
    key: '4',
    entityCategory: RiskKeys.OTHER,
    totalFunds: 34832.19,
    receivedFunds: 32037.48,
    sentFunds: 2794.71,
    totalExpenses: 8.72,
    receivedExpenses: 24.73,
    sentExpenses: 1.04,
  },
  {
    key: '5',
    entityCategory: RiskKeys.P2P_EXCHANGE,
    totalFunds: 30475.91,
    receivedFunds: 12358.76,
    sentFunds: 18117.15,
    totalExpenses: 7.63,
    receivedExpenses: 9.54,
    sentExpenses: 6.71,
  },
  {
    key: '6',
    entityCategory: RiskKeys.P2P_EXCHANGE_MLRISK_LOW,
    totalFunds: 14789.65,
    receivedFunds: 5753.21,
    sentFunds: 9036.44,
    totalExpenses: 3.7,
    receivedExpenses: 4.44,
    sentExpenses: 3.35,
  },
  {
    key: '7',
    entityCategory: RiskKeys.PAYMENT,
    totalFunds: 5092.72,
    receivedFunds: 1875.94,
    sentFunds: 3216.78,
    totalExpenses: 1.27,
    receivedExpenses: 1.45,
    sentExpenses: 1.19,
  },
  {
    key: '8',
    entityCategory: RiskKeys.SEIZED_ASSETS,
    totalFunds: 2163.99,
    receivedFunds: 686.09,
    sentFunds: 1477.9,
    totalExpenses: 0.54,
    receivedExpenses: 0.53,
    sentExpenses: 0.55,
  },
  {
    key: '9',
    entityCategory: RiskKeys.WALLET,
    totalFunds: 12256.48,
    receivedFunds: 1612.65,
    sentFunds: 10643.83,
    totalExpenses: 3.07,
    receivedExpenses: 1.25,
    sentExpenses: 3.94,
  },
  {
    key: '10',
    entityCategory: RiskKeys.ATM,
    totalFunds: 13469.27,
    receivedFunds: 4876.52,
    sentFunds: 8592.75,
    totalExpenses: 3.37,
    receivedExpenses: 3.77,
    sentExpenses: 3.18,
  },
  {
    key: '11',
    entityCategory: RiskKeys.LIQUIDITY_POOLS,
    totalFunds: 11753.98,
    receivedFunds: 3521.76,
    sentFunds: 8232.22,
    totalExpenses: 2.94,
    receivedExpenses: 2.72,
    sentExpenses: 3.05,
  },
  {
    key: '12',
    entityCategory: RiskKeys.P2P_EXCHANGE_MLRISK_HIGH,
    totalFunds: 20214.39,
    receivedFunds: 8197.52,
    sentFunds: 12016.87,
    totalExpenses: 5.06,
    receivedExpenses: 6.33,
    sentExpenses: 4.45,
  },
  {
    key: '13',
    entityCategory: RiskKeys.EXCHANGE_MLRISK_HIGH,
    totalFunds: 18524.16,
    receivedFunds: 7231.89,
    sentFunds: 11292.27,
    totalExpenses: 4.64,
    receivedExpenses: 5.58,
    sentExpenses: 4.18,
  },
  {
    key: '14',
    entityCategory: RiskKeys.CHILD_EXPLOITATION,
    totalFunds: 5368.26,
    receivedFunds: 2214.95,
    sentFunds: 3153.31,
    totalExpenses: 1.34,
    receivedExpenses: 1.71,
    sentExpenses: 1.17,
  },
  {
    key: '15',
    entityCategory: RiskKeys.DARK_MARKET,
    totalFunds: 11335.65,
    receivedFunds: 4507.31,
    sentFunds: 6828.34,
    totalExpenses: 2.84,
    receivedExpenses: 3.48,
    sentExpenses: 2.53,
  },
  {
    key: '16',
    entityCategory: RiskKeys.DARK_SERVICE,
    totalFunds: 8620.91,
    receivedFunds: 3646.19,
    sentFunds: 4974.72,
    totalExpenses: 2.16,
    receivedExpenses: 2.82,
    sentExpenses: 1.84,
  },
  {
    key: '17',
    entityCategory: RiskKeys.ENFORCEMENT_ACTION,
    totalFunds: 6421.93,
    receivedFunds: 2451.63,
    sentFunds: 3970.3,
    totalExpenses: 1.61,
    receivedExpenses: 1.89,
    sentExpenses: 1.47,
  },
  {
    key: '18',
    entityCategory: RiskKeys.EXCHANGE_FRAUDULENT,
    totalFunds: 16395.01,
    receivedFunds: 7543.29,
    sentFunds: 8851.72,
    totalExpenses: 4.1,
    receivedExpenses: 5.82,
    sentExpenses: 3.28,
  },
  {
    key: '19',
    entityCategory: RiskKeys.GAMBLING,
    totalFunds: 7684.59,
    receivedFunds: 2897.31,
    sentFunds: 4787.28,
    totalExpenses: 1.92,
    receivedExpenses: 2.24,
    sentExpenses: 1.77,
  },
  {
    key: '20',
    entityCategory: RiskKeys.ILLEGAL_SERVICE,
    totalFunds: 9521.89,
    receivedFunds: 3169.57,
    sentFunds: 6352.32,
    totalExpenses: 2.38,
    receivedExpenses: 2.45,
    sentExpenses: 2.35,
  },
  {
    key: '21',
    entityCategory: RiskKeys.MIXER,
    totalFunds: 14078.31,
    receivedFunds: 4210.68,
    sentFunds: 9867.63,
    totalExpenses: 3.52,
    receivedExpenses: 3.25,
    sentExpenses: 3.65,
  },
  {
    key: '22',
    entityCategory: RiskKeys.RANSOM,
    totalFunds: 8357.26,
    receivedFunds: 3374.92,
    sentFunds: 4982.34,
    totalExpenses: 2.09,
    receivedExpenses: 2.61,
    sentExpenses: 1.85,
  },
  {
    key: '23',
    entityCategory: RiskKeys.SANCTIONS,
    totalFunds: 7391.02,
    receivedFunds: 2619.87,
    sentFunds: 4771.15,
    totalExpenses: 1.85,
    receivedExpenses: 2.02,
    sentExpenses: 1.77,
  },
  {
    key: '24',
    entityCategory: RiskKeys.SCAM,
    totalFunds: 10614.02,
    receivedFunds: 3892.68,
    sentFunds: 6721.34,
    totalExpenses: 2.66,
    receivedExpenses: 3.01,
    sentExpenses: 2.49,
  },
  {
    key: '25',
    entityCategory: RiskKeys.STOLEN_COINS,
    totalFunds: 7127.35,
    receivedFunds: 2351.01,
    sentFunds: 4776.34,
    totalExpenses: 1.78,
    receivedExpenses: 1.82,
    sentExpenses: 1.77,
  },
  {
    key: '26',
    entityCategory: RiskKeys.TERRORISM_FINANCING,
    totalFunds: 6154.78,
    receivedFunds: 2136.54,
    sentFunds: 4018.24,
    totalExpenses: 1.54,
    receivedExpenses: 1.65,
    sentExpenses: 1.49,
  },
];
